// Motyw aplikacji: 'light' | 'dark' | 'system'. Wybór użytkownika trzymamy
// w localStorage, a rozwiązany motyw (light/dark) ląduje w atrybucie
// data-theme na <html> — z niego korzystają tokeny w assets/css/theme.css.
//
// Atrybut zamiast klasy, bo w style.css klasa .light jest już zajęta
// (pomocnik od grubości fontu) i dopisana do <html> odchudziłaby cały tekst.
//
// Ten sam odczyt robi skrypt w index.html jeszcze przed załadowaniem bundla,
// żeby strona w trybie ciemnym nie mignęła jasnym tłem.

export const THEMES = ['light', 'dark', 'system']
export const THEME_STORAGE_KEY = 'theme'

// Domyślnie jasny: tryb ciemny włącza się dopiero z wyboru użytkownika,
// więc dotychczasowi użytkownicy nie zobaczą nagłej zmiany wyglądu.
const DEFAULT_THEME = 'light'
const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)'

export function readStoredTheme() {
    try {
        const value = localStorage.getItem(THEME_STORAGE_KEY)
        return THEMES.includes(value) ? value : DEFAULT_THEME
    } catch (e) {
        return DEFAULT_THEME
    }
}

export function systemPrefersDark() {
    return window.matchMedia(COLOR_SCHEME_QUERY).matches
}

export function resolveTheme(theme, prefersDark) {
    if (theme === 'system') return prefersDark ? 'dark' : 'light'
    return theme
}

// Na czas przełączenia wyłączamy transitions — inaczej elementy z transition
// na kolorach (menu, przyciski) przechodzą płynnie, a reszta skokowo, i przez
// chwilę strona wygląda na rozjechaną.
function disableTransitionsTemporarily() {
    const style = document.createElement('style')
    style.appendChild(document.createTextNode(
        '*,*::before,*::after{-webkit-transition:none!important;transition:none!important}'
    ))
    document.head.appendChild(style)

    return () => {
        window.getComputedStyle(document.body)
        requestAnimationFrame(() => requestAnimationFrame(() => style.remove()))
    }
}

export function applyTheme(resolvedTheme) {
    const root = document.documentElement
    if (root.getAttribute('data-theme') === resolvedTheme) return

    const restoreTransitions = disableTransitionsTemporarily()
    root.setAttribute('data-theme', resolvedTheme)
    restoreTransitions()
}

// Spina motyw ze store: ustawia atrybut od razu, pilnuje zmian wyboru
// użytkownika, a w trybie systemowym także zmian ustawień systemu.
export function initTheme(store) {
    applyTheme(store.getters.resolvedTheme)
    store.watch((state, getters) => getters.resolvedTheme, applyTheme)

    const media = window.matchMedia(COLOR_SCHEME_QUERY)
    const onSystemChange = event => store.commit('change_systemPrefersDark', event.matches)
    if (media.addEventListener) {
        media.addEventListener('change', onSystemChange)
    } else {
        media.addListener(onSystemChange)
    }

    // Motyw zmieniony w innej karcie — dociągamy go tutaj.
    window.addEventListener('storage', event => {
        if (event.key === THEME_STORAGE_KEY) {
            store.commit('change_theme', readStoredTheme())
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils/theme.js